import React from "react";
import { useParams } from "react-router-dom";
import { getRoundsLeague } from '../../api/getRoundsLeague';

import BasicButtons from "../../partials/BasicButtons";
import FooterMenu from "../../partials/FooterMenu";
import HeaderTopic from "../../partials/HeaderTopic";
import RoundHeader from "./RoundHeader/RoundHeader";
import RakazButtons from "./RakazButtons/RakazButtons";
import Loading from "../Loading/Loading";

import styles from "./Rounds.module.css";

function Rounds(props) {
  const { user, league, rounds, setRounds, setMatches, refreshStates } = props;
  const { leagueId, roundId } = useParams();

  React.useEffect(() => {
    let mounted = true;

    getRoundsLeague(leagueId).then((data) => {
      if (data.error) {
      } else {
        mounted && roundId === 0 && setRounds(data.data);
      }
    });

    return function cleanup() {
      mounted = false;
    };
  }, [leagueId, setRounds, roundId]);

  return roundId === 0 ? (
    <Loading />
  ) : (
    <div className={styles.rounds}>
      <HeaderTopic topic={"ליגת " + league.name} />
      <BasicButtons user={user} refreshStates={refreshStates} />
      <FooterMenu setActive="vs" />

      <RakazButtons user={user} leagueId={leagueId} roundId={roundId} />

      <RoundHeader
        user={user}
        leagueId={leagueId}
        rounds={rounds}
        setRounds={setRounds}
        setMatches={setMatches}
      />
    </div>
  );
}

export default Rounds;
